module.exports = __webpack_public_path__ + "static/media/bottom_infographic_mobile.0508b2bb.webp";